import type { Direction } from "../../engine/direction";
import { type FrameConfig, parseFrameConfig } from "./frameConfig";

export interface AnimationConfig {
	loop: boolean;
	rotation: number;
	verticalFlip: boolean;
	horizontalFlip: boolean;
	width: number;
	height: number;
	offsetX: number;
	offsetY: number;
	pointsTo: Direction[];
	tags: Record<string, unknown>;
	frames: FrameConfig[];
}

export function parseAnimationConfig(json: any): AnimationConfig {
	if (!json.frames || !Array.isArray(json.frames)) {
		throw new Error("AnimationConfig: frames array is required");
	}

	const pointsTo: Direction[] = [];
	if (Array.isArray(json.pointsTo)) {
		for (const s of json.pointsTo) {
			pointsTo.push(s as Direction);
		}
	}

	return {
		loop: json.loop ?? false,
		rotation: json.rotation ?? 0,
		verticalFlip: json.verticalFlip ?? false,
		horizontalFlip: json.horizontalFlip ?? false,
		width: json.width ?? 1.0,
		height: json.height ?? 1.0,
		offsetX: json.offsetX ?? 0.0,
		offsetY: json.offsetY ?? 0.0,
		pointsTo,
		tags: json.tags ?? {},
		frames: json.frames.map(parseFrameConfig),
	};
}
